import React from 'react';
import { BannerSection, BannerContainer } from './Banner.style';

export const Banner: React.FC<React.PropsWithChildren<{className?: string}>> = ({
  children, className,
}): React.ReactNode => {
  return (
    <BannerSection className={className}>
      <BannerContainer>
        {children}
      </BannerContainer>
    </BannerSection>
  );
};
